import { ArdoqId } from '@ardoq/api-types';
import { ChildrenWrapper, ElWrapper } from './atoms';
import { Leaf } from './Leaf';
import { AddLeafButton } from './AddLeafButton';
import { ROOT_ID, useMetamodelEditorContext } from '../state';

type MetamodelTypeHierarchyTreeProps = {
  metamodelTypeId: ArdoqId;
  isEditable?: boolean;
};

export const MetamodelTypeHierarchyTree = ({
  metamodelTypeId,
  isEditable,
}: MetamodelTypeHierarchyTreeProps) => {
  const { usedMetamodelTypeIds, decomposedMetamodel } =
    useMetamodelEditorContext();
  const { childrenIndexes, metamodelTypes } = decomposedMetamodel;
  const childrenIds = childrenIndexes[metamodelTypeId] || [];

  const metamodelType = metamodelTypes[metamodelTypeId];

  const isRootNode = childrenIndexes[ROOT_ID].includes(metamodelTypeId);
  // The node is not a root node or not a single root node
  const isNotSingleRoot = !isRootNode || childrenIndexes[ROOT_ID]?.length > 1;
  const isRemovable = Boolean(
    isNotSingleRoot &&
    usedMetamodelTypeIds &&
    !usedMetamodelTypeIds.has(metamodelTypeId)
  );

  if (!childrenIds || !metamodelType) {
    return null;
  }
  return (
    <ElWrapper
      $isReadOnly={!isEditable}
      data-test-id={`node-${metamodelTypeId}`}
    >
      <Leaf
        metamodelType={metamodelType}
        isEditable={isEditable}
        isRemovable={isRemovable}
      />
      <ChildrenWrapper $isReadOnly={!isEditable}>
        {childrenIds.map(subMetamodelTypeId => (
          <MetamodelTypeHierarchyTree
            key={subMetamodelTypeId}
            metamodelTypeId={subMetamodelTypeId}
            isEditable={isEditable}
          />
        ))}
        {isEditable && (
          <AddLeafButton parentMetamodelTypeId={metamodelType.id} />
        )}
      </ChildrenWrapper>
    </ElWrapper>
  );
};
